import { render, staticRenderFns } from "./TransmittedReportsTable.vue?vue&type=template&id=0ae148e7&"
import script from "./TransmittedReportsTable.vue?vue&type=script&lang=js&"
export * from "./TransmittedReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./TransmittedReportsTable.vue?vue&type=style&index=0&id=0ae148e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports